export default {
  "content": "<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M21.207 4.414L19.96 5.66c3.072 4.415 2.673 10.593-1.2 14.547l-1.48-1.45c3.078-3.148 3.472-8.012 1.183-11.6l-1.77 1.77c1.399 2.561 1.037 5.872-1.092 8.05l-1.48-1.45c1.333-1.363 1.672-3.36 1.018-5.046L13 12.621v5.193a1.2 1.2 0 01-1.906.971l-2.465-1.794-3.422 3.423L3.793 19l3.198-3.2-.815-.593H3.7a1.2 1.2 0 01-1.2-1.2v-3.6a1.2 1.2 0 011.2-1.2h2.476l4.918-3.578.152-.095C12.022 5.124 13 5.68 13 6.6v3.193L19.793 3l1.414 1.414zM10.06 15.56l.94.682v-1.62l-.94.938zm-2.92-4.583a1.2 1.2 0 01-.705.23H4.5v2h1.935c.253 0 .5.08.706.23l1.282.932L11 11.793V8.171l-3.86 2.806z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};